import { Skeleton } from "@chakra-ui/react";
import React from "react";
import { GenericError } from "src/components/Feedback/GenericError";
import { MultiSelectInput } from "src/components/Inputs/MultiSelectInput";
import { RemoteDataView } from "src/components/Layout/RemoteDataView";
import { HighlightedText } from "src/components/Text/HighlightedText";
import * as RD from "src/types/remoteData";

export type Rank = {
  id: string;
  label: string;
};

type Props = {
  remoteData: RD.RemoteData<unknown, Rank[]>;
  onChange: (ranks: Rank[] | null) => void;
  selectedRanks: Rank[];
};

export const RankMultiSelectInput: React.FC<Props> = ({
  remoteData,
  onChange,
  selectedRanks,
}) => {
  return (
    <RemoteDataView
      error={() => <GenericError variant="inline" />}
      remoteData={remoteData}
      loading={<Skeleton height="1rem" width="200px" />}
    >
      {(ranks) => (
        <MultiSelectInput
          variant="check"
          leftIcon={null}
          selectAllItem={{ enable: true, text: "All ranks" }}
          options={ranks}
          placeholder="Select ranks"
          labelAttr="label"
          label={undefined}
          onChange={(newRanks) => {
            if (newRanks.length === ranks.length) {
              // all ranks
              onChange(null);
            } else {
              onChange(newRanks);
            }
          }}
          selectedItems={selectedRanks}
          size="md"
          renderDropdownItem={(option, keyword) => (
            <HighlightedText text={option.label} keyword={keyword} invert />
          )}
        />
      )}
    </RemoteDataView>
  );
};
